import React from "react";
import "./App.scss";
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import router from "./router";
import { ConfigProvider, ThemeConfig, message } from "antd";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // default: true
      retry: (failureCount: number, error: any) => {
        if (typeof error?.code === "number") {
          return false;
        }
        if (failureCount < 2) {
          return true;
        }
        return false;
      },
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      message.error(`${error.message}`);
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      message.error(`${error.message}`);
    },
  }),
});

const theme: ThemeConfig = {
  token: {
    colorPrimary: "#FCC237",
  },
  components: {
    Table: {
      headerBg: "#FCC237",
      // headerColor: "#FCC237",
      algorithm: true, // 启用算法
    },
  },
};

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider theme={theme}>
        <RouterProvider router={router} />
      </ConfigProvider>
    </QueryClientProvider>
  );
}

export default App;
